module.exports = __webpack_public_path__ + "img/quadro-armacao.4be32912.svg";